/**
 * attaches a multi tap listener for an element
 */
export function addCustomTapListener(
    callback: (event: PointerEvent) => void,
    element: HTMLElement,
    count: number,
    delay?: number
): void {
    let clicks = 0;
    let timer: ReturnType<typeof setTimeout>;
    const timeout = delay || 200;

    // click timer
    element.addEventListener('pointerdown', function pointerdown(event) {
        clearTimeout(timer);
        clicks++;

        timer = setTimeout(function clicked() {
            if (clicks === count) {
                callback(event);
            }
            clicks = 0;
        }, timeout);
    });
}
